"use client"

import styled from "@emotion/styled"
import { useTranslations } from "next-intl"
import { BalconyIcon, BuildingIcon, CheckNewIcon, NewText, RoomsIcon, SquareMetersIcon } from "ui"
import { Apartment } from "utils"

const SpecsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 37.5px;
    flex-direction: row;
    display: grid;
    column-gap: 10px;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 37.5px;
  }
`

const CharGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
  grid-column: 2 / -1;
  ${(props) => props.theme.breakpoints.up("md")} {
    column-gap: 37.5px;
  }
`
const MoreInfo = styled.div`
  display: flex;
  flex-direction: column;
`

const Char = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
`
type Props = {
  apartment: Apartment
}
function ApartmentFeatures({ apartment }: Props) {
  const t = useTranslations("AccordionDetails")
  return (
    <SpecsContainer>
      <MoreInfo>
        {
          <Char>
            <RoomsIcon
              style={{
                flexShrink: 0,
              }}
            />
            <NewText
              component={"span"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
            >
              {apartment.numberOfRooms} {t("numberOfRooms")}
            </NewText>
          </Char>
        }
        <Char>
          <BuildingIcon
            style={{
              flexShrink: 0,
            }}
          />
          <NewText
            component={"span"}
            desktopFontSize={16}
            color={"#011727"}
            desktopLineHeight={"22px"}
            mobileFontSize={16}
            mobileFontWeight={400}
            desktopFontWeight={300}
            mobileLineHeight={"22px"}
          >
            {t("building")} {apartment.buildingTitle}
          </NewText>
        </Char>
        <Char>
          <SquareMetersIcon
            style={{
              flexShrink: 0,
            }}
          />
          <NewText
            component={"span"}
            desktopFontSize={16}
            color={"#011727"}
            desktopLineHeight={"22px"}
            mobileFontSize={16}
            mobileFontWeight={400}
            desktopFontWeight={300}
            mobileLineHeight={"22px"}
          >
            {apartment.areaInSquareMeters} {t("sqm")}
          </NewText>
        </Char>
        <Char>
          <BalconyIcon
            style={{
              flexShrink: 0,
            }}
          />
          <NewText
            component={"span"}
            desktopFontSize={16}
            color={"#011727"}
            desktopLineHeight={"22px"}
            mobileFontSize={16}
            mobileFontWeight={400}
            desktopFontWeight={300}
            mobileLineHeight={"22px"}
          >
            {apartment.balconySquareMeter} {t("balconySqm")}
          </NewText>
        </Char>
      </MoreInfo>
      <CharGrid>
        {apartment.apartmentNumber && (
          <Char>
            <CheckNewIcon
              style={{
                flexShrink: 0,
              }}
            />
            <NewText
              component={"span"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
            >
              {t("apartmentNumber")} {apartment.apartmentNumber}
            </NewText>
          </Char>
        )}
        {apartment.floor && (
          <Char>
            <CheckNewIcon
              style={{
                flexShrink: 0,
              }}
            />
            <NewText
              component={"span"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
            >
              {t("floor")} {apartment.floor}
            </NewText>
          </Char>
        )}
        {typeof apartment?.houseCommitee === "number" || apartment?.houseCommitee ? (
          <Char>
            <CheckNewIcon
              style={{
                flexShrink: 0,
              }}
            />
            <NewText
              component={"span"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
            >
              {t("boardfee")} {apartment.houseCommitee}
            </NewText>
          </Char>
        ) : null}
        {apartment.orientation && (
          <Char>
            <CheckNewIcon
              style={{
                flexShrink: 0,
              }}
            />
            <NewText
              component={"span"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
            >
              {t("direction")} {apartment.orientation}
            </NewText>
          </Char>
        )}
        {apartment.apartmentCharacteristics.map((el, i) => (
          <Char key={i}>
            <CheckNewIcon
              style={{
                flexShrink: 0,
              }}
            />
            <NewText
              component={"span"}
              desktopFontSize={16}
              color={"#011727"}
              desktopLineHeight={"22px"}
              mobileFontSize={16}
              mobileFontWeight={400}
              desktopFontWeight={300}
              mobileLineHeight={"22px"}
            >
              {el}
            </NewText>
          </Char>
        ))}
      </CharGrid>
    </SpecsContainer>
  )
}
export default ApartmentFeatures
